import { createContext, useContext } from 'react'
import type { TimelineEvent } from '@/types/timeline'

/** Ouvre le panneau « Détails » d'un appel du fil. Absent hors de la boîte
 * de réception : la carte d'appel n'affiche alors pas le bouton. */
export const DetailsAppelContext = createContext<((event: TimelineEvent) => void) | null>(null)

export const useOuvrirDetailsAppel = () => useContext(DetailsAppelContext)
